
import * as companySelector from './company'

export {
    companySelector
}



// WEBPACK FOOTER //
// src/selectors/index.js